import { render } from "./assetsearch.vue?vue&type=template&id=76fabd1b"
import script from "./assetsearch.vue?vue&type=script&lang=js"
export * from "./assetsearch.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__